import React from "react";

import { StatusBadgeProps } from "~/pages/purchase-orders/types/sales-notes";

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  size = "sm",
}) => {
  // Size-based class
  const sizeClass = size === "xs" ? "text-xs" : "text-sm";

  switch (status) {
    case "accepted":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-green-100 text-green-800`}
        >
          Aprobada
        </span>
      );
    case "por_facturar":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-blue-100 text-blue-800`}
        >
          Por Facturar
        </span>
      );
    case "in_transit":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-blue-100 text-blue-800`}
        >
          En Tránsito
        </span>
      );
    case "pending":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-amber-100 text-amber-800`}
        >
          Autorización Cobranza
        </span>
      );
    case "pending_pricing":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-purple-100 text-purple-800`}
        >
          Autorización por Precio
        </span>
      );
    case "pending_credit":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-red-100 text-red-800`}
        >
          Crédito Insuficiente
        </span>
      );
    case "prepaid":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-orange-100 text-orange-800`}
        >
          Anticipado Pendiente de Pago
        </span>
      );
    case "payment_to_check":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-yellow-100 text-yellow-800`}
        >
          Validación Pago
        </span>
      );
    case "delivered":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-blue-100 text-blue-800`}
        >
          Entregado
        </span>
      );
    case "rejected":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-red-100 text-red-800`}
        >
          Rechazada
        </span>
      );
    case "test":
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-gray-100 text-gray-800`}
        >
          Test
        </span>
      );
    default:
      return (
        <span
          className={`rounded-full px-2 py-1 ${sizeClass} bg-gray-100 text-gray-800`}
        >
          {status.charAt(0).toUpperCase() + status.slice(1).replace(/_/g, " ")}
        </span>
      );
  }
};

export default StatusBadge;
